import { Alert, Button, Modal, Stack, TextInput } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { AlertPresets } from "../../../mantine/mantinePresets";

interface AuthDeactivationModalProps {
  isOpen: boolean;
  otp: string;
  isEmail2FaActive: boolean;
  error?: string | null;
  onToggle: () => void;
  onAuthDeactivation: () => void;
  onOtpChange: (value: string) => void;
  onOtpResend: () => void;
}

function AuthDeactivationModal({
  isOpen,
  otp,
  isEmail2FaActive,
  error,
  onToggle,
  onAuthDeactivation,
  onOtpChange,
  onOtpResend
}: AuthDeactivationModalProps) {
  const deactivationCodeLabel = isEmail2FaActive
    ? "Um die Zwei-Faktor-Authentifizierung zu deaktivieren, geben Sie bitte den Code ein, den wir Ihnen per E-Mail zugesandt haben."
    : "Um die Zwei-Faktor-Authentifizierung zu deaktivieren, geben Sie bitte den Code aus Ihrer Authentifizierungs-App ein.";

  return (
    <Modal
      opened={isOpen}
      title="Bitte bestätigen Sie die Deaktivierung"
      onClose={onToggle}
    >
      <TextInput
        label={deactivationCodeLabel}
        placeholder="XXXXXX"
        required
        value={otp}
        onChange={(e) => onOtpChange(e.target.value)}
      />

      <Stack mt="sm">
        {error && <Alert color={AlertPresets.error.color}>{error}</Alert>}
        {isEmail2FaActive && (
          <Button p={0} variant="transparent" onClick={onOtpResend}>
            Senden Sie den Code erneut
          </Button>
        )}
      </Stack>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Schließen
        </Button>
        <Button color="error" onClick={onAuthDeactivation}>
          Speichern
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { AuthDeactivationModal, AuthDeactivationModalProps };
